/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

export const WorkPackageStatuses = {
  NOT_READY: 'Not Ready',
  GETTING_READY: 'Getting Ready',
  READY: 'Ready',
  IN_PROGRESS: 'In Progress',
  COMPLETED: 'Completed',
  ACCEPTED: 'Accepted',
  SHIPPABLE: 'Shippable',
  LIVE: 'Live'
};

export const HigherLevelStatuses = {
  NOT_READY: 'Funnel',
  GETTING_READY: 'Analyzing',
  READY: 'Backlog',
  IN_PROGRESS: 'Implementing',
  COMPLETED: 'Validating',
  ACCEPTED: 'Deploying',
  SHIPPABLE: 'Releasing',
  LIVE: 'Live'
};

export const CadenceStatuses = {
  GETTING_READY: 'Getting Ready',
  IN_PROGRESS: 'In Progress',
  ACCEPTED: 'Accepted'
};
